import {useContext, useEffect} from "react";
import {GlobalContext} from "./context/GlobalContextProvider.jsx";
import useAuthorityConfiguration from "../api/utilities/useAuthorityConfiguration.js";
import {UserApi} from "../api/authority/generated/index";
import toast from "react-hot-toast";

let userSettingsRequestUserId = null;
let userSettingsRequestPromise = null;

/**
 * @returns {[UserSettings|null,updateUserSettings]}
 */
export default function useUserSettings() {

    let {context, setUserSettings, setUserSettingsLoading} = useContext(GlobalContext);

    let authorityConfiguration = useAuthorityConfiguration();

    let updateUserSettings = (newUserSettings) => {
        new UserApi(authorityConfiguration)
            .updateUserSettings({
                userId: context.currentIdentity.user.id,
                userSettings: newUserSettings,
            })
            .then(setUserSettings)
            .catch(() => {
                toast.error('Unable to save user settings.');
            });
    };

    useEffect(() => {
        let userId = context.currentIdentity?.user?.id;
        if (!userId || context.currentUserSettingsLoaded) {
            return;
        }

        if (userSettingsRequestPromise !== null && userSettingsRequestUserId === userId) {
            return;
        }

        setUserSettingsLoading(true);

        userSettingsRequestUserId = userId;
        userSettingsRequestPromise = new UserApi(authorityConfiguration)
            .getUserSettings({
                userId: userId,
            })
            .then(setUserSettings)
            .catch(() => {
                setUserSettingsLoading(false);
                toast.error('Unable to load user settings.');
            })
            .finally(() => {
                userSettingsRequestUserId = null;
                userSettingsRequestPromise = null;
            });
    }, [authorityConfiguration, context.currentIdentity?.user?.id, context.currentUserSettingsLoaded, setUserSettings, setUserSettingsLoading]);

    return [context.currentUserSettings, updateUserSettings];
}
